import {createAsyncThunk} from "@reduxjs/toolkit";
import i18n from "../../config/i18n";
import ExpenseService, {IExpenseCreateEdit, IExpenseFilters} from "../../api/expenseService";
import {toastError, toastSuccess} from "../../component/shared/toast/Toast";
import {getSafeBackendErrorMessage} from "../../util/utils";
import {SliceNames} from "../constants";

export const getExpenses =
    createAsyncThunk(`${SliceNames.EXPENSE}/getExpenses`,
        async (req: { page: number, limit: number, filters?: IExpenseFilters }, thunkAPI) => {
            try {
                const res = await ExpenseService.fetchExpenses(req.page, req.limit, req.filters)
                return res.data
            } catch (e: any) {
                toastError(getSafeBackendErrorMessage(e.response?.data?.detail))
                return thunkAPI.rejectWithValue(e)
            }
        })

export const getExpenseCategories =
    createAsyncThunk(`${SliceNames.EXPENSE}/getExpenseCategories`,
        async (_, thunkAPI) => {
            try {
                const res = await ExpenseService.fetchExpenseCategories()
                return res.data
            } catch (e: any) {
                toastError(getSafeBackendErrorMessage(e.response?.data?.detail))
                return thunkAPI.rejectWithValue(e)
            }
        })

export const createExpense =
    createAsyncThunk(`${SliceNames.EXPENSE}/createExpense`,
        async (req: {
            expense: IExpenseCreateEdit,
            handleCloseDialog: () => void,
            onSuccess?: () => void
        }, thunkAPI) => {
            try {
                const res = await ExpenseService.createExpense(req.expense)
                req.handleCloseDialog()
                req.onSuccess?.()
                toastSuccess(i18n.t('changes_saved_success'))
                return res.data
            } catch (e: any) {
                toastError(getSafeBackendErrorMessage(e.response?.data?.detail))
                return thunkAPI.rejectWithValue(e)
            }
        })

export const updateExpense =
    createAsyncThunk(`${SliceNames.EXPENSE}/updateExpense`,
        async (req: {
            expenseId: string,
            expense: IExpenseCreateEdit,
            handleCloseDialog: () => void,
            onSuccess?: () => void
        }, thunkAPI) => {
            try {
                const res = await ExpenseService.updateExpense(req.expenseId, req.expense)
                req.handleCloseDialog()
                req.onSuccess?.()
                toastSuccess(i18n.t('changes_saved_success'))
                return res.data
            } catch (e: any) {
                toastError(getSafeBackendErrorMessage(e.response?.data?.detail))
                return thunkAPI.rejectWithValue(e)
            }
        })

export const deleteExpense =
    createAsyncThunk(`${SliceNames.EXPENSE}/deleteExpense`,
        async (req: {
            expenseId: string,
            handleCloseDialog: () => void,
            onSuccess?: () => void
        }, thunkAPI) => {
            try {
                await ExpenseService.deleteExpense(req.expenseId)
                req.handleCloseDialog()
                req.onSuccess?.()
                toastSuccess(i18n.t('changes_saved_success'))
                return req.expenseId
            } catch (e: any) {
                toastError(getSafeBackendErrorMessage(e.response?.data?.detail))
                return thunkAPI.rejectWithValue(e)
            }
        })
